import { ThemeProvider } from '@emotion/react';
import { Box, Stack } from '@mui/material';
import React from 'react';
import { generateTheme } from '../themes';
import { RPMButton } from './subComponents/RPMButton';
import { RPMText } from './subComponents/RPMText';
import { RPMImage } from './subComponents/RPMImage';

const InfoGridSlice = ({ data }) => {
    const {
        colorTheme = 'white',
        items = []
    } = data;

    const theme = generateTheme(colorTheme);

    const renderItems = () => {
        return items.map((item, index) => {
            const {
                image: itemimage,
                title: itemtitle,
                text: itemtext,
                primaryLink: itemlinkprimarylink,
                primaryLinkText: itemlinkprimarytext,
                secondaryLink: itemlinksecondarylink,
                secondaryLinkText: itemlinksecondarytext,
                buttonStyle: itembuttonStyle = 'filled'
                        } = item;

            return (
                <Box id={"gridItem" + index} key={index} sx={{ display: 'flex',  flexDirection: 'column', width: "100%", backgroundColor: 'background.light', p: { xs: 6, md: 10 }, pb: { xs: 6, md: itemlinksecondarylink ? 2.5 : 6.5 }, borderRadius: 3, gap: 1 }}>
                    {itemimage && (
                        <Box sx={{ width: '100%', alignItems: "center", display: "flex", justifyContent: "center" }}>
                            <RPMImage image={itemimage} borderRadius="7px" sx={{ width: '100%', mb: 2, maxWidth: "500px", alignItems: "center", display: "flex" }} />
                        </Box>
                    )}
                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "flex-start" }}>
                        {itemtitle && <RPMText content={itemtitle} variant='h4' elementRenderType="h3" />}
                        {itemtext && <RPMText content={itemtext} variant='p' />}
                    </Box>
                    <Box sx={{ flex: itemlinkprimarylink ? "1" : "0.2" }} />
                    <Stack direction="column" spacing={0} sx={{ position: "relative", alignItems: "center" }}>
                        {itemlinkprimarylink && (
                            <RPMButton link={{ url: itemlinkprimarylink }} linktext={itemlinkprimarytext} type={
                                itembuttonStyle === 'outlined' ? 'outlined' :
                                itembuttonStyle === 'outlined-contrast' ? 'outlined-contrast' :
                                itembuttonStyle === 'filled-contrast' ? 'contained-contrast' :
                                'contained'
                            } />
                        )}
                        {itemlinksecondarylink && (
                            <RPMButton link={{ url: itemlinksecondarylink }} linktext={itemlinksecondarytext} type="text" />
                        )}
                        {((!itemlinksecondarylink) || (!itemlinkprimarylink)) && (
                            <Box sx={{ height: "8px" }} />
                        )}
                    </Stack>
                </Box>
            );
        });
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', p: 0 }}>
                <Stack spacing={{ xs: 4, md: 6 }} direction={{ xs: "column", md: "row" }} sx={{ flex: 1, p: { xs: 4, md: 6, lg: 12 }, mb: { xs: 0, md: 0 }, background: (theme) => theme.palette.background.default, justifyContent: 'flex-start', alignItems: 'strech' }}>
                    {renderItems()}
                </Stack>
            </Box>
        </ThemeProvider>
    );
};

export default InfoGridSlice;